import '@babel/polyfill'
import 'mutationobserver-shim'
import Vue from 'vue'
import { BootstrapVue, IconsPlugin } from 'bootstrap-vue'

// Import Bootstrap an BootstrapVue CSS files (order is important)
import 'bootstrap/dist/css/bootstrap.css'
import 'bootstrap-vue/dist/bootstrap-vue.css'

import './plugins/axios'
import App from './App.vue'
import router from './router'
import store from './store'
import Toasted from 'vue-toasted'
import 'font-awesome/css/font-awesome.min.css'
import './assets/css/main.scss'
import config from '@/config'
import './plugins/dayjs'
import './plugins/event-bus'
import VueNativeSock from 'vue-native-websocket'
import vMultiselectListbox from 'vue-multiselect-listbox'
import 'vue-multiselect-listbox/src/scss/vue-multi-select-listbox.scss'
// Make BootstrapVue available throughout your project
Vue.use(BootstrapVue)
// Optionally install the BootstrapVue icon components plugin
Vue.use(IconsPlugin)

Vue.use(Toasted, {
  position: 'top-right',
  duration: 3000
})
Vue.component('VueFontawesome', require('vue-fontawesome-icon/VueFontawesome.vue').default)

Vue.component('v-multiselect-listbox', vMultiselectListbox)
store.commit('initStore')

Vue.config.productionTip = false

Vue.use(VueNativeSock, config.wsUrl + '?token=' + store.getters['auth/apiToken'], {
  format: 'json',
  reconnection: true,
  reconnectionAttempts: 10,
  reconnectionDelay: 3000,
  connectManually: true
})

new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app')
